import { gql } from '@apollo/client';

export const FETCH_SIGN_NOW_ENVELOPE = gql`
  query Flex_FetchSignNowEnvelope($id: Int!) {
    signNowEnvelope(id: $id) {
      id
      status
      signingUrl
      inviteExpiresAt
    }
  }
`;
